import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46e38ecb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "payment-summary-card"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "status paid"
}
const _hoisted_4 = {
  key: 1,
  class: "status pending"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode()
const _hoisted_6 = { class: "total-paid" }
const _hoisted_7 = {
  key: 0,
  class: "pending-status-container"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Queden ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" pendents de pagar")
const _hoisted_10 = {
  key: 1,
  class: "pending-status-container"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Comanda pagada")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_ctx.paymentInfo.total_paid > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("payment.payments")), 1),
        _createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.completedPayments, (payment) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                key: payment.id
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(payment.user), 1),
                      (payment.status === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("payment.paid")), 1))
                        : _createCommentVNode("", true),
                      (payment.status === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("payment.pendingPayment")), 1))
                        : _createCommentVNode("", true),
                      _hoisted_5,
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$filters.currency(payment.total)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        (!_ctx.paymentInfo.paid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.currency(_ctx.pendingPayment)), 1),
              _hoisted_9
            ]))
          : _createCommentVNode("", true),
        (_ctx.paymentInfo.paid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_ion_icon, { icon: _ctx.checkmarkCircleOutline }, null, 8, ["icon"]),
              _hoisted_11
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}